import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useProcess } from "../../contexts/ProcessContext"
import { getConfiguredFunctions } from "@/firebase/configuredFunctions"
import { httpsCallable } from "firebase/functions"

export default function ResetPassword() {
   const navigate = useNavigate()
   const { startProcess } = useProcess()
   const [email, setEmail] = useState("")

   const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault()
      startProcess(async () => {
         const requestResetPassword = httpsCallable(
            getConfiguredFunctions(),
            "requestResetPassword",
         )
         await requestResetPassword({ email })
         // navigate("/connexion")
      })
   }

   return (
      <div className="h-full flex items-center justify-center">
         <div className="card w-96 bg-base-100 shadow-xl">
            <div className="card-body">
               <h2 className="card-title">Réinitialiser le mot de passe</h2>
               <p className="text-sm text-base-content/70">
                  Entrez votre adresse email pour recevoir un lien de réinitialisation.
               </p>
               <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="form-control">
                     <label className="label">
                        <span className="label-text">Email</span>
                     </label>
                     <input
                        id="username"
                        name="username"
                        autoComplete="username"
                        type="email"
                        className="input input-bordered w-full"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                     />
                  </div>

                  <div className="space-y-2">
                     <button type="submit" className="btn btn-primary w-full">
                        Envoyer le lien
                     </button>
                     <button
                        type="button"
                        className="btn btn-ghost w-full"
                        onClick={() => navigate("/connexion")}
                     >
                        Retour à la connexion
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   )
}
